import { type PropsWithChildren, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { MutationSignalContext } from '@spotify/confidence-graphql';

import { useRecentActivity } from './useRecentActivity';

export const RecentActivityProvider = ({ children }: PropsWithChildren) => {
  const { recordActivity, recordView } = useRecentActivity();
  const { pathname } = useLocation();

  useEffect(() => {
    recordView(pathname);
  }, [pathname, recordView]);

  return (
    <MutationSignalContext.Provider value={recordActivity}>
      {children}
    </MutationSignalContext.Provider>
  );
};
